import { useEffect } from 'react';

export const useInsideClick = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  handleInsideClick?: boolean,
): void => {
  const handler = (e: MouseEvent) => {
    if (ref.current?.contains(e.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    if (handleInsideClick) {
      document.addEventListener('mousedown', handler);
      return () => {
        document.removeEventListener('mousedown', handler);
      };
    }
    return () => {};
  }, []);
};
